import { EmptyTableResults } from '@/components/Table/styles';
import { TableType } from '@/components/Table/types/types';
import { MASTER_ADMIN_BILLING_EVENTS_CONFIG } from '../const/const';
import { InternalOrganizationBillingEventType } from '@/api/v1/organization/internal/getInternalOrganizationBillingEventsApi';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';
import { NoResults } from '@/components/NoResults/NoResults';
import NoItemsIcon from '@/images/NoItemsIcon.svg?react';
import { MobileTable } from '@/components/Table/MobileTable/MobileTable';
import { DesktopTable } from '@/components/Table/DesktopTable';

export const BillingEventsTable = ({ items = [], isLoading }: TableType<InternalOrganizationBillingEventType>) => {
  const { isMobile } = useResponsiveDevice();

  const hasItems = !!items.length;
  const noItems = !hasItems && !isLoading;

  if (noItems) {
    return (
      <EmptyTableResults>
        <NoResults icon={<NoItemsIcon />} message='No billable events are recorded yet.' />
      </EmptyTableResults>
    );
  }

  return isMobile ? (
    <MobileTable config={MASTER_ADMIN_BILLING_EVENTS_CONFIG} items={items} isLoading={isLoading} />
  ) : (
    <DesktopTable
      config={MASTER_ADMIN_BILLING_EVENTS_CONFIG}
      items={items}
      isLoading={isLoading}
      isClickableRow={false}
    />
  );
};
